<template>
  <CmStateCard
    title="Статистика по доменам"
    :isLoading="isLoading"
    :isError="isError"
    :isEmpty="!info.length"
    class="stat-domains-card"
    :disabled="disabled"
  >
    <CmDonutCard
      centerLabel="Доставлено"
      rowKey="domain"
      countKey="delivered"
      :centerValue="totalNum"
      :value="info"
      :cols="cols"
      :colors="['#56D9FE', '#FC7907', '#00CA64', '#A3A1FB', '#FFDA83', '#FF8373', '#E8E8E8']"
      :getTooltipTemplate="getTooltipTemplate"
    />
  </CmStateCard>
</template>

<script>
import { mapActions } from "vuex";
import { getPercent } from "@/utils/general";

import CmStateCard from '@/components/library/statistics/cards/CmStateCard.vue';
import CmDonutCard from '@/components/library/statistics/cards/CmDonutCard.vue';

export default {
  name: "DeliveryDomains",

  components: {
    CmStateCard,
    CmDonutCard,
  },
  props:{
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      cols: {
        domain: {
          label: "Домен",
          className: "legend-name-td--dots-overflow",
        },
        sent: {
          label: "Отправлено",
        },
        delivered: {
          label: "Доставлено",
          isPercent: true,
        },
        errors: {
          label: "Ошибки",
          isPercent: true,
        },
      },
    };
  },

  computed: {
    value() {
      return this.$store.getters.statDomains;
    },
    isLoading() {
      return this.$store.state.stat.loadings.domains;
    },
    isError() {
      return this.$store.state.stat.errors.domains;
    },
    info() {
      const formedData = [];
      if (this.value.length) {
        this.value.forEach(item => {
          formedData.push({
            domain: item.domain,
            sent: item.sent,
            delivered: item.delivered,
            delivered_percent: item.deliveredPercent,
            errors: item.errors,
            errors_percent: item.errorsPercent,
          });
        });
      }

      return formedData;
    },

    totalNum() {
      if (this.info.length) {
        return this.info.reduce(
          (total, d) => total + d.delivered, 0,
        );
      }

      return 0;
    },
  },

  methods: {
    getTooltipTemplate(data) {
      return `<h4 class="tooltip-title">${data.domain}</h4>
        <span>
          <b>${getPercent(this.totalNum, data.delivered)}%</b>
          от всех доставленных писем
        </span>
        <span>
          Ошибки&nbsp;&nbsp;
          ${this.fNum.format(data.errors)}&nbsp;&nbsp;
          ${data.errors_percent}%
        </span>`;
    },
  },
};
</script>

<style lang="scss">
.stat-domains-card {
  table thead td:first-of-type {
    font-weight: 400;
  }
  .cm-donut-card .legend-name-td {
    max-width: 100px;
  }

  .tooltip-title::first-letter {
    text-transform: capitalize;
  }
}
</style>